module.exports = __webpack_public_path__ + "img/3.去你的脂肪（戴军.dcfee973.jpg";